import React, { useState, useEffect } from "react";

export default function pageNotFound() {
  return (
    <React.Fragment>
      <h1>Page Not Found!.</h1>
    </React.Fragment>
  );
}
